import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = {
  style: {"display":"inline-block"},
  class: "col-12"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h1", {
    class: "h2",
    style: {"text-align":"left"}
  }, "ソリューション"),
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  style: {"cursor":"pointer","margin-bottom":"1%","padding":"2%"},
  class: "card col-5 offset-1 float-start"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, " センサを利用する ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  style: {"cursor":"pointer","margin-bottom":"1%","padding":"2%"},
  class: "card col-5 offset-1 float-end"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, " 制御デバイスを利用する ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  style: {"cursor":"pointer","margin-bottom":"1%","padding":"2%"},
  class: "card col-5 offset-1 float-start"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", null, " グラフを作成する ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = {
  style: {"cursor":"pointer","margin-bottom":"1%","padding":"2%"},
  class: "card col-5 offset-1 float-end"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, " フォルダ機能を追加する ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  style: {"cursor":"pointer","margin-bottom":"1%","padding":"2%"},
  class: "card col-5 offset-1 float-start"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", null, " 積雪IoTを追加する ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div style=\"display:inline-block;\" class=\"col-12\"><br><div class=\"col-12\"><h1 class=\"h2\" style=\"text-align:left;\">サンプルプロジェクト</h1><hr></div><div class=\"col-12\"></div></div><div style=\"display:inline-block;\" class=\"col-12\"><br><div class=\"col-12\"><h1 class=\"h2\" style=\"text-align:left;\">事例</h1><hr></div><div class=\"col-12\"><div style=\"margin-bottom:1%;padding:2%;\" class=\"card col-5 offset-1 float-start\"><br><b><a href=\"https://momo-ltd.com/contact/\" target=\"_blank\"> お問い合わせ ・開発のご相談 等はこちらから </a></b><br></div></div></div><br>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.faMicrochip,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addMenu([{'path':'/sensors/','menu-title':'センサ','title':'センサ'}]))),
            style: {"margin":"0 auto"},
            size: "5x"
          }, null, 8, ["icon"]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.faTablet,
            style: {"margin":"0 auto"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addMenu([{'path':'/devices/','menu-title':'デバイス','title':'デバイス'}]))),
            size: "5x"
          }, null, 8, ["icon"]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.faChartBar,
            style: {"margin":"0 auto"},
            size: "5x",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addMenu([{'path':'/custom/dashboard/data','menu-title':'データ','title':'データ','editmode':true, 'date-search': true,'aggregate': true,'particlesize': true,'initial-particlesize': '1hour','initial-aggregate': 'median','sensorids':[],'tabs': []}])))
          }, null, 8, ["icon"]),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _hoisted_23,
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.faFile,
            style: {"margin":"0 auto"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addMenu([{'path':'/file/list/','menu-title':'ファイル','title':'ファイル'}]))),
            size: "5x"
          }, null, 8, ["icon"]),
          _hoisted_24
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          _hoisted_28,
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.faSnowflake,
            style: {"margin":"0 auto"},
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addMenu([{'path':'/snow/','menu-title':'積雪','title':'積雪'}]))),
            size: "5x"
          }, null, 8, ["icon"]),
          _hoisted_29
        ]),
        _hoisted_30
      ])
    ], 512), [
      [_vShow, _ctx.showDashboardEdit]
    ]),
    _hoisted_31
  ], 512)), [
    [_vShow, _ctx.showViews]
  ])
}